export const iconFontAwesomeDesignStamp = (
	<i className="fa-solid fa-stamp"></i>
);
